var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaguette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182 183",
    style: {
      enableBackground: "new 0 0 182 183"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.9,1.1c0,0,0-0.1,0-0.2c-0.1-0.4-0.4-0.6-0.7-0.7c-0.1,0-100.1-0.1-100.4,0.1c-0.2,0.1-0.3,0.2-0.4,0.4 c-0.2,0.4-0.1,181.5-0.1,181.6c0,0.2,0.2,0.4,0.3,0.5c0.4,0.3,100.5,0.2,100.8,0.1C142.2,182.5,141.9,195.1,141.9,1.1z M140.2,180 c-2.8-2.8-8-8-10.8-10.8V14l10.8-10.8V180z M42.1,3.2c2.8,2.8,8,8,10.8,10.8v155.1L42.1,180V3.2z M126.3,14.5 c-1.6,1.6-4.7,4.7-6.3,6.3H62.3l-6.3-6.3H126.3z M62.8,160.5V22.6h56.7v137.9H62.8z M54.7,167.4V15.8l6.3,6.3V161 C59.4,162.7,56.3,165.7,54.7,167.4z M55.9,168.6c1.6-1.6,4.7-4.7,6.3-6.3H120l6.3,6.3H55.9z M121.2,22.1c1.6-1.6,4.7-4.7,6.3-6.3 v151.6l-6.3-6.3V22.1z M138.9,1.9l-10.8,10.8c-35.9,0-72.5,0-73.9,0c-2.8-2.8-8-8-10.8-10.8H138.9z M54.2,170.4c49.3,0,73,0,73.9,0 c2.8,2.8,8,8,10.8,10.8H43.3L54.2,170.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaguette);
export default __webpack_public_path__ + "static/media/baguette.de68742ea63bc55cdebacc163bc2d8e4.svg";
export { ForwardRef as ReactComponent };